import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

/** Identifier type for public.sea_ice_forecast_file_status_ */
export type SeaIceForecastFileStatusId = string & {
  __brand: 'SeaIceForecastFileStatusId'
}

/** Represents the table public.sea_ice_forecast_file_status_ */
export default interface SeaIceForecastFileStatusTable {
  /** Database type: pg_catalog.text */
  id: ColumnType<
    SeaIceForecastFileStatusId,
    SeaIceForecastFileStatusId,
    SeaIceForecastFileStatusId
  >

  /** Database type: pg_catalog.text */
  description: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date, Date | string | undefined, Date | string>
}

export type SeaIceForecastFileStatus = Selectable<SeaIceForecastFileStatusTable>

export type SeaIceForecastFileStatusInitializer =
  Insertable<SeaIceForecastFileStatusTable>

export type SeaIceForecastFileStatusMutator =
  Updateable<SeaIceForecastFileStatusTable>

export const seaIceForecastFileStatusId =
  z.string() as unknown as z.Schema<SeaIceForecastFileStatusId>

export const seaIceForecastFileStatus = z.object({
  id: seaIceForecastFileStatusId,
  description: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
}) as unknown as z.Schema<SeaIceForecastFileStatus>

export const seaIceForecastFileStatusInitializer = z.object({
  id: seaIceForecastFileStatusId,
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<SeaIceForecastFileStatusInitializer>

export const seaIceForecastFileStatusMutator = z.object({
  id: seaIceForecastFileStatusId.optional(),
  description: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<SeaIceForecastFileStatusMutator>
